/* USER PROFILE COMPONENT *****************************************************/

/* react redux */
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Widgets */
import Switch from 'widget/switch'
import TextInput from 'widget/text-input'
import InfoText from 'widget/info-text'
import DropdownButton from 'widget/dropdown-button'
import { Icon, ICON } from 'widget/icon'

/* Actions */
import { save as saveLanguage } from 'react-redux/actions/language'
import {
  logout,
  saveName,
  saveSurname,
  savePassword,
  saveOrganizationSchedule,
  fetchOrganizationSchedule
} from 'react-redux/actions/user'

/* Styles */
import './profile.css'

class UserProfile extends Component {

  constructor(props) {
    super(props)
    this.state = {
      validPassword: false,
      passwordNotification: null,
      currentPassword: "",
      newPassword: "",
      repeatedPassword: ""
    }
  }

  componentWillMount() {
    //const { fetchOrganizationSchedule } = this.props
    //const { applicationStartup } = this.props
    //applicationStartup()
    //console.log("fetchOrganizationSchedule")
    //fetchOrganizationSchedule()
  }

  componentDidUpdate(prevProps, prevState) {
    if(
      prevState.currentPassword !== this.state.currentPassword
      || prevState.newPassword !== this.state.newPassword
      || prevState.repeatedPassword !== this.state.repeatedPassword
    )
    this.validatePassword()
  }

  onSaveName(value) {
    const { saveName } = this.props
    saveName(value)
  }

  onSaveSchedule(value) {
    //console.log("onSaveSchedule", value)
    const { saveOrganizationSchedule } = this.props
    saveOrganizationSchedule(value)
    //const { saveName } = this.props
    //saveName(value)
  }

  validateName(value) {
    return value && value.length
  }

  onSaveSurname(value) {
    const { saveSurname } = this.props
    saveSurname(value)
  }

  validateSurname(value) {
      return value && value.length
  }


  /* Helpers */

  getItemClass() {
    var className = "user-profile component"
    return className
  }

  setLanguage(value) {
    const { saveLanguage } = this.props
    saveLanguage(value)
  }

  onCurrentPasswordChange(e) {
    this.setState({currentPassword: e.target.value})
  }

  onNewPasswordChange(e) {
    this.setState({newPassword:e.target.value})
  }

  onRepeatPasswordChange(e) {
    this.setState({repeatedPassword: e.target.value})
  }

  validatePassword() {
    const { currentPassword, newPassword, repeatedPassword } = this.state
    if (!currentPassword && !newPassword  && !repeatedPassword) {
      this.setState({ validPassword: false, passwordNotification: null})
    } else if (!currentPassword) {
      this.setState({
         validPassword: false,
         passwordNotification: "user:profile.noCurrentPassword"
      })
    } else if (!newPassword) {
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.noNewPassword"
      })
    } else if (newPassword.length < 6) {
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.newPasswordToShort"
      })
    } else if (newPassword !== repeatedPassword){
      this.setState({
        validPassword: false,
        passwordNotification: "user:profile.passwordsDontMatch"
      })
    } else {
      this.setState({ validPassword: true, passwordNotification: null})
    }
  }

  onChangePasswordClick(e) {
    const { validPassword, currentPassword, newPassword } = this.state
    const { savePassword } = this.props
    if (!validPassword) return
    savePassword(currentPassword, newPassword)
    this.setState(
      {
        validPassword: true,
        passwordNotification: null,
        currentPassword: "",
        newPassword: "",
        repeatedPassword: ""
      }
    )
  }

  renderPasswordNotification() {
    const { t } = this.props
    const { validPassword, passwordNotification } = this.state
    if (!validPassword && passwordNotification) return (
      <InfoText text={ t(passwordNotification)}></InfoText>
    )
  }

  renderPasswordChangeButton() {
    const { validPassword } = this.state
    const { t } = this.props
    if (!validPassword) return (
      <button className="action" disabled="disabled" >
        { t('user:profile.passwordChangeButtonLabel') }
      </button>
    )
    return (
      <button  className="action"
        onClick={ this.onChangePasswordClick.bind(this) }
      >
        { t('user:profile.passwordChangeButtonLabel') }
      </button>
    )
  }

  render() {
    const { currentPassword, newPassword, repeatedPassword } = this.state
    const { t, name, surname, language, organizationSchedule } = this.props
    return (
      <div className={ this.getItemClass() }>
        <div className="row">
          <div className="column name">
            <div className="column-list">
              <div className="header">
                <h2>{ t("user:profile.nameHeadline") }</h2>
              </div>
              <div className="body">
                <TextInput
                  className="nameInput"
                  value={ name }
                  ref={ (elem) => { this.nameInput = elem }}
                  placeholder={ t('user:profile.nameInput.placeholder') }
                  onSave={ this.onSaveName.bind(this) }
                  validate={ this.validateName.bind(this) }
                  />
                <TextInput
                  className="surnameInput"
                  value={ surname }
                  ref={ (elem) => { this.surnameInput = elem }}
                  placeholder={ t('user:profile.surnameInput.placeholder') }
                  onSave={ this.onSaveSurname.bind(this) }
                  validate={ this.validateSurname.bind(this) }
                  />
              </div>
            </div>
          </div>
            <div className="column password">
              <div className="column-list">
                <div className="header">
                  <h2>{ t("user:profile.passwordHeadline") }</h2>
                </div>
                <div className="body">
                  <TextInput
                    className="currentPasswordInput"
                    password={ true }
                    noSave={ true }
                    noUndo={ true }
                    value={ currentPassword }
                    ref={ (elem) => { this.currentPasswordInput = elem }}
                    placeholder={
                      t('user:profile.currentPasswordInput.placeholder')
                    }
                    onInput={ this.onCurrentPasswordChange.bind(this) }
                  />
                  <TextInput
                    className="passwordInput"
                    password={ true }
                    noSave={ true }
                    noUndo={ true }
                    value={ newPassword }
                    ref={ (elem) => { this.passwordInput = elem }}
                    placeholder={ t('user:profile.passwordInput.placeholder') }
                    onInput={ this.onNewPasswordChange.bind(this) }
                  />
                  <TextInput
                    className="passwordRepeatInput"
                    password={ true }
                    noSave={ true }
                    noUndo={ true }
                    value={ repeatedPassword }
                    ref={ (elem) => { this.passwordRepeatInput = elem }}
                    placeholder={
                       t('user:profile.passwordRepeatInput.placeholder')
                     }
                    onInput={ this.onRepeatPasswordChange.bind(this) }
                  />
                  { this.renderPasswordNotification() }
                  { this.renderPasswordChangeButton() }
                </div>
              </div>
            </div>
            <div className="column language">
              <div className="column-list">
                <div className="header">
                  <h2>{ t("user:profile.languageHeadline") }</h2>
                </div>
                <div className="body">
                  <DropdownButton
                    label={ t('user:language.'+language) }
                    title={ t('user:profile.languageTitle') }
                    icon={ ICON.CARET_DOWN }
                    menu={   {
                      align: "right",
                      items:[{
                        name: t('user:language.de'),
                        title: t('user:language.de'),
                        onClick: () => { this.setLanguage("de")}
                      },
                      {
                        name: t('user:language.en'),
                        title: t('user:language.en'),
                        onClick: () => { this.setLanguage("en")}
                      }]
                    } }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row2">
          <div className="column">
            <div className="column-list">
              <div className="header">
                <h2>{ t("user:profile.organizationHeadline") }</h2>
              </div>
              <div className="body">
                <Switch
                  className="scheduleSwitch"
                  value={ organizationSchedule }
                  labelRight={ true }
                  label={ t('user:profile.scheduleSwitch.label') }
                  ref={ (elem) => { this.scheduleSwitch = elem }}
                  title={ t('user:profile.scheduleSwitch.title') }
                  onSave={ this.onSaveSchedule.bind(this) }
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

UserProfile.propTypes = {}

const mapStateToProps = (state) => {
  return state.user
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveLanguage,
      saveName,
      saveSurname,
      savePassword,
      saveOrganizationSchedule,
      fetchOrganizationSchedule
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfile)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/user/profile.jsx